@if (templateData$ | glxyAsyncStatus | async; as result) {
  @switch (result.status) {
    @case ('loading') {
      <glxy-page [pagePadding]="false">
        <glxy-page-toolbar> </glxy-page-toolbar>
        <glxy-loading-spinner [inline]="true" [fullWidth]="false"></glxy-loading-spinner>
      </glxy-page>
    }
    @default {
      <glxy-page>
        <glxy-page-toolbar> </glxy-page-toolbar>
        <p>There was a problem loading the content</p>
      </glxy-page>
    }
    @case ('loaded') {
      <glxy-page [pagePadding]="false">
        <glxy-page-toolbar>
          <glxy-page-actions>
            <button
              mat-raised-button
              [disabled]="result.status !== 'loaded' || htmlRendering"
              color="primary"
              (click)="save()"
              >
              Save
            </button>
          </glxy-page-actions>
        </glxy-page-toolbar>
        <email-builder
          [emailContent]="result.value"
          (emailContentChanged)="stageDataForSaving($event)"
          (emailRenderUpdated)="stageRawHtmlForSaving($event)"
          (htmlRendering)="setHtmlRendering($event)"
          [advancedSections]="ALL_ADVANCED_SECTIONS_ENABLED"
          [dynamicComponents]="dynamicComponents"
        ></email-builder>
      </glxy-page>
    }
  }
}
